// Čtení claimů z JWT tokenu bez ověření podpisu — jen pro klientské rozhodování
// (kdy token vyprší, kdy ho obnovit). Ověření dělá vždy server.

// Vrátí payload tokenu, nebo null když token nejde dekódovat.
export function decodeJwt(token) {
  try {
    const part = token.split('.')[1]
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(json)
  } catch {
    return null
  }
}

// { exp, iat } v milisekundách, nebo null když token claimy nemá.
export function tokenTimes(token) {
  const p = token ? decodeJwt(token) : null
  if (!p?.exp) return null
  return { exp: p.exp * 1000, iat: (p.iat ?? p.exp) * 1000 }
}
